import { baseApi } from 'core/api';
import { useOrganizationStore } from 'store/modules';

const state = () => ({
    _button: 'Send',
    _color: '#1d95f3',
    _domains: [''],
    _header: 'Text Us',
    _message: 'Hey there! Click Here to start texting us! 🙂',
    _status: true,
    _position: 'right',
    _team_id: null,
    _hasSettings: false,
    _opt_in_text: null,
});

const getters = {
    chatSettings: (state) => ({
        button: state._button,
        color: state._color,
        domains: state._domains,
        header: state._header,
        message: state._message,
        status: state._status,
        position: state._position,
        team_id: state._team_id,
        hasSettings: state._hasSettings,
        opt_in_text: state._opt_in_text,
    }),
    chatColor: (state) => state._color,
    hasSettings: (state) => state._hasSettings,
};

const actions = {
    handleSaveChatWidget(form) {
        return form
            .post('core/chats')
            .then((response) => {
                const settings = {
                    ...response.data,
                    hasSettings: true,
                };

                this._setChatUpdateSettings(settings);

                return response.data;
            })
            .catch((e) => {
                this._setChatUpdateSettings({
                    hasSettings: false,
                });

                throw e;
            });
    },

    handleGetChatWidget() {
        return baseApi
            .get('core/chats')
            .then((response) => {
                const settings = {
                    ...response.data,
                    hasSettings: true,
                };

                if (settings.opt_in_text === null) {
                    const name = useOrganizationStore().organization?.name;
                    settings.opt_in_text = `By submitting you authorize ${name} to send text messages with offers & other information, possibly using automated technology, to the number you provided. Message / data rates apply.`;
                }

                this._setChatUpdateSettings(settings);

                return response.data;
            })
            .catch((e) => {
                const name = useOrganizationStore().organization?.name;
                const opt_in_text = `By submitting you authorize ${name} to send text messages with offers & other information, possibly using automated technology, to the number you provided. Message / data rates apply.`;

                this._setChatUpdateSettings({
                    hasSettings: false,
                    status: false,
                    opt_in_text,
                });

                throw e;
            });
    },

    handleUpdateChatSetting(data = {}) {
        this._setChatUpdateSettings(data);
    },

    handleChangeChatSettingStatus({ status }) {
        return baseApi.post('core/chats/status', { status });
    },

    // Private methods
    _setChatUpdateSettings(data) {
        for (let key in data) {
            if (key === 'status') {
                this._status = !!data[key];
            } else if (key === 'team_id') {
                this._team_id = +data[key];
            } else if (key === 'button') {
                this._button = data[key];
            } else if (key === 'color') {
                this._color = data[key];
            } else if (key === 'domains') {
                this._domains = data[key];
            } else if (key === 'header') {
                this._header = data[key];
            } else if (key === 'message') {
                this._message = data[key];
            } else if (key === 'position') {
                this._position = data[key];
            } else if (key === 'hasSettings') {
                this._hasSettings = data[key];
            } else if (key === 'opt_in_text') {
                this._opt_in_text = data[key];
            }
        }
    },
};

export default {
    state,
    getters,
    actions,
};
